import { invoiceAmounts } from '../../utils/invoiceAmounts';
import { formatRupiah } from '../../utils/printHelper';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { format } from 'date-fns';
import { id } from 'date-fns/locale';
import { CalendarIcon } from 'lucide-react';
import { Calendar } from '../ui/calendar';

export function TukarFakturDialog({ catatanTukar, handleTukarFaktur, setCatatanTukar, setShowTukarFaktur, setTanggalTukar, showTukarFaktur, tanggalTukar, tukarFakturInvoice, tukarLoading }) {
  return (
    <Dialog open={showTukarFaktur} onOpenChange={setShowTukarFaktur}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-amber-600">Tukar Faktur</DialogTitle>
          <p className="text-sm text-slate-600">Invoice akan dipindahkan ke Payment Request setelah tukar faktur</p>
        </DialogHeader>
        {tukarFakturInvoice && (
          <div className="space-y-4">
            <div className="bg-amber-50 p-3 rounded-lg border border-amber-200">
              <p className="font-semibold">{tukarFakturInvoice.invoice_number}</p>
              <p className="text-sm text-slate-600">{tukarFakturInvoice.supplier_name}</p>
              <p className="text-sm font-mono">Rp {formatRupiah(invoiceAmounts(tukarFakturInvoice).nilaiDibayarkan)}</p>
            </div>

            <div className="space-y-2">
              <Label>Tanggal Tukar Faktur</Label>
              <Popover modal={false}>
                <PopoverTrigger asChild>
                  <Button variant="outline" className="w-full justify-start text-left font-normal">
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {tanggalTukar ? format(tanggalTukar, 'dd MMMM yyyy', { locale: id }) : 'Pilih tanggal'}
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0 z-[100]">
                  <Calendar
                    mode="single"
                    selected={tanggalTukar}
                    onSelect={setTanggalTukar}
                    initialFocus
                  />
                </PopoverContent>
              </Popover>
            </div>

            <div className="space-y-2">
              <Label>Catatan (Opsional)</Label>
              <Input
                value={catatanTukar}
                onChange={(e) => setCatatanTukar(e.target.value.toUpperCase())}
                placeholder="Masukkan catatan..."
                data-testid="tukar-faktur-catatan"
              />
            </div>

            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setShowTukarFaktur(false)}>
                Batal
              </Button>
              <Button 
                className="bg-amber-600 hover:bg-amber-700"
                onClick={handleTukarFaktur}
                disabled={tukarLoading}
                data-testid="confirm-tukar-faktur"
              >
                {tukarLoading ? 'Memproses...' : 'Tukar Faktur'}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
